import React, { useEffect, useRef, useState } from 'react'
import { Loading, Select } from '@yisa/webui'
import { ResultBox } from '@yisa/webui_business'
import ajax from '@/services'

function Left() {

  const chartRef = useRef()
  const [range, setRange] = useState(7)
  const [loading, setLoading] = useState(true)
  const [xData, setXData] = useState([])
  const [yData, setYData] = useState([])

  const selectOptions = [
    {
      label: '近7天',
      value: 7
    },
    {
      label: '近15天',
      value: 15
    },
    {
      label: '近30天',
      value: 30
    }
  ]

  const handleGetData = () => {
    setLoading(true)
    ajax.getMarketStatistics({
      range: range,
      unit: 0
    }).then(res => {
      const { range, list } = res?.data || {}
      if (Array.isArray(range) && range.length && Array.isArray(list) && list.length) {
        setXData(range)
        setYData(list.map(elem => ({
          type: 'line',
          name: elem.behavior,
          data: elem.nums
        })))
      } else {
        setXData([])
        setYData([])
      }
    }).catch(err => {
      console.log(err)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    const handleResize = () => {
      chartRef.current && chartRef.current.resize()
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      chartRef.current && chartRef.current.dispose()
    }
  }, [])

  useEffect(() => {
    handleGetData()
  }, [range])

  useEffect(() => {
    if (xData.length && yData.length) {
      handleInitChart()
    } else {
      chartRef.current && chartRef.current.dispose()
    }
  }, [xData, yData])

  const handleInitChart = () => {
    const chartDom = document.getElementById('markerChart')
    const myChart = echarts.getInstanceByDom(chartDom) ?? echarts.init(chartDom)
    const option = {
      title: {
        show: true,
        text: '违规行为数量统计',
        left: 'center',
        textStyle: {
          lineHeight: 32,
          color: '#fff',
        }
      },
      color: ['#4d9fff', '#27fccd', '#ffc62c', '#68bb0a', '#ff3a3a', '#794aff'],
      legend: {
        top: 40,
        show: true,
        textStyle: {
          color: '#fff'
        }
      },
      grid: {
        top: 80,
        left: 60,
        right: 60,
        bottom: 60
      },
      tooltip: {
        show: true,
        trigger: 'axis',
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLabel: {
          color: '#fff'
        },
        axisPointer: {
          type: 'shadow'
        },
        axisLine: {
          lineStyle: {
            color: ['rgba(255,255,255,.5)'],
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#fff',
        },
        splitNumber: 5,
        splitLine: {
          lineStyle: {
            color: ['rgba(255,255,255,.5)'],
            type: 'dashed'
          }
        }
      },
      series: yData
    }
    myChart.setOption(option)
    chartRef.current = myChart
  }

  return (
    <div className="market-content market-content-left">
      {
        loading && <div className="loading">
          <Loading spinning />
        </div>
      }
      {
        !loading && !xData.length && <div className="loading">
          暂无统计数据
        </div>
      }
      <Select
        disabled={loading}
        className="market-filter"
        options={selectOptions}
        value={range}
        onChange={setRange}
      />
      <div id="markerChart" className="market-chart" />
    </div>
  )
}

export default Left
